import VirtualScroller from "/WebInterface/new-ui/modules/virtualscroll.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import ContextMenu from "/WebInterface/new-ui/modules/contextmenu/contextmenu.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import ListingTemplates from "/WebInterface/new-ui/manage-shares/js/templates/listing.js";
import {
  getManageShareListing,
  deleteManageShareItems,
} from "/WebInterface/new-ui/manage-shares/utils/api.js";
import store from "/WebInterface/new-ui/manage-shares/js/reducer.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { sortingOrder } from "/WebInterface/new-ui/assets/js/constants.js";
import { initShareDetails } from "/WebInterface/new-ui/manage-shares/modules/modals/share-details/share-details.js";
import setLocale from "/WebInterface/new-ui/manage-shares/js/localization.js";
import { initMatchingModal } from "/WebInterface/new-ui/manage-shares/modules/modals/select-matching-accounts/select-matching-accounts.js";

const contextMenuItems = [
  {
    iconClass: "icon-copy",
    i18nkey: "selectSimilar",
    method: "select-similar",
  },
  {
    iconClass: "icon-trash",
    i18nkey: "Delete",
    method: "delete",
  },
];

// To invoke parent methods
function invoke(method, params) {
  if (parent.window[method]) {
    return parent.window[method].apply(this, params);
  }
}

const tableContextMenuDetails = {
  created: t("created"),
  expires: t("expires"),
  emailTo: t("to"),
  paths: t("paths"),
  remainingUses: t("remainingUses"),
  download: t("download"),
  comments: t("comments"),
};

let virtualScroller;
let contextMenu;

const appendSotingIcon = (currentSortingStatus, parent) => {
  const sortingIconClass =
    currentSortingStatus?.order === sortingOrder?.ASC
      ? "icon-sort-down"
      : "icon-sort-up";
  const sortingIcon = _$("<i>");
  sortingIcon
    .el()
    .classList.add(sortingIconClass, "sorting-icon", "text-accentMain");
  parent.appendChild(sortingIcon.el());
};

const fetchMangeShareListing = async () => {
  const loader = new Loader({});

  _$(".sorting-icon")
    .sel()
    .forEach((icon) => {
      icon?.remove();
    });

  const manageShare_DateFormat = invoke("getUserCustomizationValue", [
    "manageShare_DateFormat",
    true,
  ]);
  const dateFormat = utils.dateStringFormat({
    format: manageShare_DateFormat,
    fromManageShares: true,
  });

  try {
    const response = await getManageShareListing();
    let shareList = response?.listingInfo?.listingInfo_subitem;

    // shareList.unshift({
    //   ...shareList[0],
    //   paths: "/<img src=x onerror='prompt(1)'>.txt"
    // })
    if (shareList && !Array.isArray(shareList)) {
      shareList = [shareList];
    }
    const _shareList = shareList?.map((item) => {
      return {
        ...item,
        emailTo_formatted: utils.textEncode(
          typeof item?.emailTo === "string" ? item?.emailTo : "-"
        ),
        comments_formatted: utils.textEncode(
          typeof item?.share_comments === "string" ? item?.share_comments : ""
        ),
        login_allowance_formatted: utils.textEncode(
          item?.login_allowance === "-1" ? "Unlimited" : item?.login_allowance
        ),
        created: manageShare_DateFormat
          ? flatpickr.formatDate(
              item?.createdMillis
                ? new Date(Number(item?.createdMillis))
                : flatpickr.parseDate(item?.expire, "m/d/Y G:i K"),
              dateFormat
            )
          : item?.created,
        expire: manageShare_DateFormat
          ? flatpickr.formatDate(
              item?.expireMillis
                ? new Date(Number(item?.expireMillis))
                : flatpickr.parseDate(item?.expire, "m/d/Y G:i K"),
              dateFormat
            )
          : item?.expire,
        paths_encoded: utils.textEncode(item?.paths || "") || "",
        id: utils.getUId(),
        checked: false,
      };
    });

    store.dispatch("setManageSharesList", _shareList);
  } catch (error) {
    console.log(error);
  } finally {
    loader.deleteLoader();
  }
};

const renderManageShareList = async () => {
  const shareList = store?.shareList;

  const scrollTopBeforeRerender = virtualScroller?.container?.scrollTop || 0;

  const unCheckedItem = shareList.find((item) => !item?.checked);
  const checkAllCheckBox = _$("#checkAll");
  checkAllCheckBox.el().checked =
    unCheckedItem || shareList?.length === 0 ? false : true;

  virtualScroller?.init({
    totalRows: shareList.length,
    generatorFn: (rowIndex) => {
      const item = shareList[rowIndex];

      // Setting Attribute Of List Items
      const divLi = _$("<tr>").el();
      divLi.classList.add("table-tr");
      divLi.setAttribute("tabindex", 0);
      divLi.setAttribute("data-index", rowIndex);
      divLi.setAttribute("data-uid", item.id);

      // Displaying Item According To item Type
      divLi.innerHTML = ListingTemplates.TreeItem({
        rowIndex: rowIndex,
        checked: item?.checked ? "checked" : "",
        created: item?.created,
        expires: item?.expire,
        to: item?.emailTo_formatted,
        paths: item?.paths_encoded,
        remainingUses: item?.login_allowance_formatted,
        comments: item?.comments_formatted,
        downloads: item?.downloads,
      });

      const checkbox = _$(divLi).find(".manage-shares-list-checks");
      checkbox.on("change", () => {
        store.dispatch("toggleCheck", {
          itemId: item?.id,
          checked: checkbox.el().checked,
        });
      });

      _$(divLi)
        .find("td")
        .on("click", (e) => {
          if (e.currentTarget.contains(checkbox.el())) return;
          initShareDetails(rowIndex);
        });

      _$(divLi)
        .find("td")
        .on("contextmenu", (e) => {
          window.focus();
          const currentTarget = e.currentTarget;
          if (currentTarget?.contains(checkbox.el())) return;

          contextMenu.init({
            contextMenuItems,
            onClick: async (btn, elem) => {
              const method = btn?.method;

              switch (method) {
                case "select-similar":
                  const contextMenuKey = currentTarget?.dataset?.contextmenuKey;
                  if (!contextMenuKey) return;

                  const title = tableContextMenuDetails[contextMenuKey];
                  const value = item[contextMenuKey];

                  initMatchingModal(title, value, contextMenuKey);
                  break;
                case "delete":
                  const resp = await Confirm({
                    title: `<span data-i18n-key='confirm'>${t(
                      "confirm"
                    )}</span>`,

                    body: `<span data-i18n-key="areYouSureYouWantToDeleteSelectedAccounts" data-i18n-opt='{"count":"1"}'>${t(
                      "areYouSureYouWantToDeleteSelectedAccounts",
                      { count: 1 }
                    )}</span>`,

                    confirm: `<span data-i18n-key='ok'>${t("ok")}</span>`,
                    cancel: `<span data-i18n-key='cancel'>${t(
                      "cancel"
                    )}</span>`,
                    closable: false,
                  });
                  if (resp) {
                    try {
                      let username = item?.username;
                      const shareUsername = item?.usernameShare === "true";
                      if (shareUsername) {
                        const paths = item?.paths;
                        username += `:${paths}`;
                      }
                      await deleteManageShareItems({
                        tempUsername: `${username};`,
                      });
                      store.dispatch("refreshShareListing");
                    } catch (error) {
                      console.log(error);
                    }
                  }
                  break;
                default:
                  break;
              }
            },
          });
          contextMenu.handleContextMenu(e, item);
        });

      return divLi;
    },
  });

  const vList = _$("#manage-shares-virtual-list");
  vList.html("");

  if (shareList.length === 0) {
    const listContainer = _$("<div>").el();
    listContainer.className =
      "h-full is-flex is-align-items-center is-justify-content-center is-flex-direction-column";
    listContainer.innerHTML = `<p class="text-base text-primaryMain has-text-weight-semibold mb-2" data-i18n-key="nothingToDisplay">${t(
      "nothingToDisplay"
    )}</p><img src="/WebInterface/new-ui/assets/images/no-file-found.png" alt="nothingToDisplay" />`;

    vList.el().append(listContainer);
    return;
  }

  vList.el().append(virtualScroller?.container);
  virtualScroller.container.scrollTop = scrollTopBeforeRerender;
};

const handleURLParams = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const theme = urlParams.get("theme");
  const lang = urlParams.get("lang");

  if (theme) {
    _$("html").attr("data-theme", theme);
  }

  if (lang) {
    _$("html").attr("lang", lang);
  }
};

const renderTableHeader = () => {
  _$("#manage-shares-table-wrapper").html(
    ListingTemplates.TreeHeader({
      created: t("Created"),
      expires: t("Expires"),
      to: t("To"),
      paths: t("Paths"),
      remainingUses: t("Remaining Uses"),
      comments: t("Comments"),
      downloads: t("Download"),
    })
  );

  let tableWidth = -1;

  _$("#manage-shares-table-wrapper th")
    .sel()
    .forEach((th) => {
      tableWidth += th?.clientWidth;
    });

  _$("#manage-shares-table-wrapper table").el().style.width = `${tableWidth}px`;

  // Sort event
  _$(".table-header").on("click", (e) => {
    const sortField = e.currentTarget?.dataset?.sortKey;

    if (!sortField) {
      return;
    }

    const sortingStatus = store.sortingStatus;
    const currentSortingStatus = sortingStatus[sortField];

    _$(".sorting-icon")
      .sel()
      .forEach((icon) => {
        icon?.remove();
      });
    appendSotingIcon(currentSortingStatus, e.currentTarget);

    store.dispatch("sortShareList", { sortField });
  });
};

const subscribe = () => {
  const manageSharesActions = [
    {
      eventName: "setManageSharesList",
      callback: renderManageShareList,
    },
    {
      eventName: "toggleCheckAll",
      callback: renderManageShareList,
    },
    {
      eventName: "toggleCheck",
      callback: renderManageShareList,
    },
    {
      eventName: "searchItemsByValue",
      callback: renderManageShareList,
    },
    {
      eventName: "sortShareList",
      callback: renderManageShareList,
    },
    {
      eventName: "refreshShareListing",
      callback: fetchMangeShareListing,
    },
    {
      eventName: "selectItemsWithSameKeyValuePair",
      callback: renderManageShareList,
    },
  ];

  manageSharesActions.forEach((action) => {
    store.subscribe(action.eventName, action.callback);
  });
};

_$("body").ready(() => {
  subscribe();

  virtualScroller = new VirtualScroller({
    width: "100%",
    itemHeight: 40,
    maxRowsToShow: 100,
    topOffset: 5,
  });

  contextMenu = new ContextMenu({
    contextElementId: "context-menu",
  });

  renderTableHeader();

  // Refresh event
  _$("#refreshButton").on("click", () => {
    _$("#manage-shares-search-input").val("");
    fetchMangeShareListing();
  });

  // Check All event
  const checkAllCheckBox = _$("#checkAll");
  checkAllCheckBox.on("change", (e) => {
    const checked = checkAllCheckBox.el().checked;
    store.dispatch("toggleCheckAll", { checked });
  });

  // Delete event
  const deleteSelectedItems = _$("#manageShareDeleteSelectedItems");
  deleteSelectedItems.on("click", async () => {
    const shareList = store.shareList;

    const selectedItems = shareList.filter((item) => item?.checked === true);

    if (selectedItems.length === 0) {
      growl("", t("nothingSelected"), 5000, true);
      return;
    }

    const usernames = selectedItems.map((item) => {
      let username = item?.username;
      const shareUsername = item?.usernameShare === "true";
      if (shareUsername) {
        const paths = item?.paths;
        username += `:${paths}`;
      }
      return username;
    });

    const resp = await Confirm({
      title: `<span data-i18n-key='confirm'>${t("confirm")}</span>`,

      body: `<span data-i18n-key="areYouSureYouWantToDeleteSelectedAccounts" data-i18n-opt='{"count":"${
        usernames.length
      }"}'>${t("areYouSureYouWantToDeleteSelectedAccounts", {
        count: usernames.length,
      })}</span>`,

      confirm: `<span data-i18n-key='ok'>${t("ok")}</span>`,
      cancel: `<span data-i18n-key='cancel'>${t("cancel")}</span>`,
      closable: false,
    });
    if (resp) {
      try {
        await deleteManageShareItems({ tempUsername: usernames.join(";") });
        fetchMangeShareListing();
      } catch (error) {
        console.log(error);
      }
    }
  });

  // Search event
  const handleSearchValue = utils.debounce((value) => {
    store.dispatch("searchItemsByValue", { value });
  }, 500);

  _$("#manage-shares-search-input").on("input", (e) => {
    const inputValue = e.target.value.trim();
    handleSearchValue(inputValue);
  });

  window.addEventListener("resize", () => {
    renderTableHeader();
    renderManageShareList();
  });

  // message event from parent document to this iframe
  window.addEventListener("message", function (event) {
    const { key, value } = event.data;
    switch (key) {
      case "theme":
        _$("html").attr("data-theme", value);
        break;
      case "language":
        setLocale(value);
        break;
      case "overrideFontFamily":
        document.documentElement.style.setProperty("--font-family", value);
        break;
      case "applyTemporaryTheme":
        const temporaryCSSTheming = _$("#temporaryCSSTheming").el();

        if (temporaryCSSTheming) {
          temporaryCSSTheming.textContent = `${value}`;
        } else {
          const dynamicStyle = document.createElement("style");
          dynamicStyle.textContent = `${value}`;
          dynamicStyle.id = "temporaryCSSTheming";
          document.head.appendChild(dynamicStyle);
        }
        break;
      default:
        break;
    }
  });

  handleURLParams();
  fetchMangeShareListing();
});
